import { useState } from 'react';

import { ChannelHealthPanel } from '../../components/channels/ChannelHealthPanel';
import { ChannelsList } from '../../components/channels/ChannelsList';
import { ConnectChannelModal } from '../../components/channels/ConnectChannelModal';
import { Button } from '../../components/ui/button';
import { Skeleton } from '../../components/ui/skeleton';
import { useChannelList } from '../../hooks/use-channels';

export function ChannelsPage() {
  const { data, isLoading, isError } = useChannelList();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [connectOpen, setConnectOpen] = useState(false);

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <h1 className="text-lg font-semibold">Каналы</h1>
        <Button onClick={() => setConnectOpen(true)}>Подключить канал</Button>
      </div>
      <div className="flex min-h-0 flex-1">
        <div className="min-w-0 flex-1 overflow-y-auto">
          {isLoading && (
            <div className="space-y-2 p-4">
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} className="h-10 w-full" />
              ))}
            </div>
          )}
          {isError && <div className="p-4 text-sm text-red-600">Не удалось загрузить каналы.</div>}
          {!isLoading && !isError && (
            <ChannelsList channels={data ?? []} selectedId={selectedId} onSelect={setSelectedId} />
          )}
        </div>
        {selectedId && <ChannelHealthPanel channelId={selectedId} onClose={() => setSelectedId(null)} />}
      </div>
      <ConnectChannelModal open={connectOpen} onClose={() => setConnectOpen(false)} />
    </div>
  );
}
